<template>
  <div id="enterprise-create-form-wrapper" class="vx-col m-5 mt-12">
    <vx-card class="enterprise-create-form h-full overflow-hidden">
      <div class="vx-row no-gutter justify-center items-center h-full">
        <div class="vx-col sm:w-full md:w-full lg:w-full h-full">
          <div
            class="
              send-email
              create-enterprise-tabs-container
              flex flex-col
              gap-8
              h-full
              overflow-hidden
            "
            v-if="!isEnterpriseCreateSuccess"
          >
            <div class="vx-card__title h-8 flex justify-start items-center">
              <h4 class="aisea-text-16-400-black">
                {{
                  messages.beforeCreate.titleFirstHalf
                }}<span class="required"></span
              >{{ messages.beforeCreate.titleSecondHalf }}
              </h4>
            </div>
            <!-- 法人ID -->
            <div class="vx-row overflow-auto h-full row-gap-8">
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.enterpriseInfo.loginKeyLabel
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="loginKey"
                  v-validate="
                    'required|regex:^[0-9A-Za-z@\\-_.]+$|min:2|max:64'
                  "
                  name="enterpriseInfo.loginKey"
                  :data-vv-as="messages.enterpriseInfo.loginKey"
                  :placeholder="placeholders.enterpriseInfo.loginKey"
                />
                <span>
                  {{ messages.enterpriseInfo.loginKeyExplanation }}
                </span>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('enterpriseInfo.loginKey')"
                >{{ errors.first("enterpriseInfo.loginKey") }}</span
                >
              </div>
              <!-- 法人名 -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.enterpriseInfo.name
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="enterpriseName"
                  v-validate="'required|min:1|max:32'"
                  name="enterpriseInfo.name"
                  :data-vv-as="messages.enterpriseInfo.name"
                  :placeholder="placeholders.enterpriseInfo.name"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('enterpriseInfo.name')"
                >{{ errors.first("enterpriseInfo.name") }}</span
                >
              </div>
              <!-- 法人名(カナ) -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.enterpriseInfo.nameKana
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="enterpriseNameKana"
                  v-validate="'required|regex:^[\u30A1-\u30FF\x20\u3000]+$|min:1|max:64'"
                  name="enterpriseInfo.nameKana"
                  :data-vv-as="messages.enterpriseInfo.nameKana"
                  :placeholder="placeholders.enterpriseInfo.nameKana"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('enterpriseInfo.nameKana')"
                >{{ errors.first("enterpriseInfo.nameKana") }}</span
                >
              </div>
              <!-- 郵便番号 -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.enterpriseInfo.zipCode
                  }}</label>
                <div class="flex justify-start items-center col-gap-5">
                  <vs-input
                    class="input-zip-code"
                    v-model="zipCode"
                    v-validate="'required|regex:^[0-9]{7}$|min:7|max:7'"
                    name="enterpriseInfo.zipCode"
                    :data-vv-as="messages.enterpriseInfo.zipCode"
                    :placeholder="placeholders.enterpriseInfo.zipCode"
                  />
                  <vs-button
                    id="search-address-button-with-loading"
                    class="search-address-btn text-center px-5 py-3"
                    type="border"
                    color="primary"
                    @click="handleClickSearchAddressBtn"
                    :disabled="!isZipCodeValid"
                  >{{ messages.beforeCreate.searchAddress }}
                  </vs-button
                  >
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('enterpriseInfo.zipCode')"
                >{{ errors.first("enterpriseInfo.zipCode") }}</span
                >
              </div>
              <!-- 住所 -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.enterpriseInfo.address
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="address"
                  v-validate="'required|min:1|max:56'"
                  name="enterpriseInfo.Address"
                  :data-vv-as="messages.enterpriseInfo.address"
                  :placeholder="placeholders.enterpriseInfo.address"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('enterpriseInfo.Address')"
                >{{ errors.first("enterpriseInfo.Address") }}</span
                >
              </div>
              <!-- 代表電話番号 -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.enterpriseInfo.phoneNumber
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="phoneNumber"
                  v-validate="'numeric|custom_phoneNumber'"
                  name="enterpriseInfo.phoneNumber"
                  :data-vv-as="messages.enterpriseInfo.phoneNumber"
                  :placeholder="placeholders.enterpriseInfo.phoneNumber"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('enterpriseInfo.phoneNumber')"
                >{{ errors.first("enterpriseInfo.phoneNumber") }}</span
                >
              </div>
              <!-- 担当者部署 -->
              <div class="vx-col w-full mw flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.accountInfo.department
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="department"
                  type="string"
                  v-validate="'min:1|max:128'"
                  name="accountInfo.department"
                  :data-vv-as="messages.accountInfo.department"
                  :placeholder="placeholders.accountInfo.department"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('accountInfo.department')"
                >{{ errors.first("accountInfo.department") }}</span
                >
              </div>
              <!-- 担当者役職 -->
              <div class="vx-col w-full mw flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.accountInfo.title
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="title"
                  type="string"
                  v-validate="'min:1|max:128'"
                  name="accountInfo.title"
                  :data-vv-as="messages.accountInfo.title"
                  :placeholder="placeholders.accountInfo.title"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('accountInfo.title')"
                >{{ errors.first("accountInfo.title") }}</span
                >
              </div>
              <!-- 担当者名 -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.accountInfo.name
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="accountName"
                  type="string"
                  v-validate="'required|min:1|max:32'"
                  name="accountInfo.name"
                  :data-vv-as="messages.accountInfo.name"
                  :placeholder="placeholders.accountInfo.name"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('accountInfo.name')"
                >{{ errors.first("accountInfo.name") }}</span
                >
              </div>
              <!-- 担当者名(カナ) -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.accountInfo.nameKana
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="accountNameKana"
                  type="string"
                  v-validate="'required|regex:^[\u30A1-\u30FF\x20\u3000]+$|min:1|max:64'"
                  name="accountInfo.nameKana"
                  :data-vv-as="messages.accountInfo.nameKana"
                  :placeholder="placeholders.accountInfo.nameKana"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('accountInfo.nameKana')"
                >{{ errors.first("accountInfo.nameKana") }}</span
                >
              </div>
              <!-- メールアドレス -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.enterpriseInfo.emailAddress
                  }}</label>
                <vs-input
                  disabled
                  class="w-full"
                  v-model="mailAddress"
                  type="email"
                  v-validate="'required|min:8|max:128'"
                  name="enterpriseInfo.emailAddress"
                  :data-vv-as="messages.enterpriseInfo.emailAddress"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('enterpriseInfo.emailAddress')"
                >{{ errors.first("enterpriseInfo.emailAddress") }}</span
                >
              </div>
              <!-- パスワード -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.accountInfo.passwordLabel
                  }}</label>
                <vs-input
                  class="w-full input-password"
                  v-model="password"
                  :type="passwordInputType"
                  v-validate="'required|regex:^[!-~]+$|min:8|max:64'"
                  name="accountInfo.password"
                  :data-vv-as="messages.accountInfo.password"
                  :placeholder="placeholders.accountInfo.password"
                  icon-no-border
                  icon-after
                  icon-pack="material-icons material-icons-outlined"
                  :icon="passwordIconType"
                  @icon-click="handleClickShowPasswordBtn"
                />
                <span>
                  {{ messages.accountInfo.passwordExplanation }}
                </span>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('accountInfo.password')"
                >{{ errors.first("accountInfo.password") }}</span
                >
              </div>
              <!-- オプトイン -->
              <div class="vx-col w-full mw required flex flex-col row-gap-2">
                <div class="flex flex-wrap justify-between">
                  <vs-checkbox v-model="isOptin" class="mb-3 aisea-text-16-400-black">
                    「<a
                    :href="urlTermsOfService"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ messages.nav.termsOfService }}</a
                  >」「<a
                    :href="urlPryvacyPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ messages.nav.privacyPolicy }}</a
                  >」に同意する
                  </vs-checkbox>
                </div>
              </div>
            </div>
            <div>
              <!-- 登録ボタン -->
              <div class="flex justify-end">
                <vs-button
                  id="create-enterprise-button-with-loading"
                  class="
                    text-center
                    vs-con-loading__container
                    aisea-text-14-400-white
                  "
                  @click="createEnterprese"
                  :disabled="!validateForm"
                >{{ messages.beforeCreate.send }}
                </vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="
              after-create-enterprise
              create-enterprise-tabs-container
              flex flex-col
              gap-3
              h-full
              overflow-auto
            "
            v-else
          >
            <!-- 登録後に表示 -->
            <div class="vx-card__title h-8 flex justify-start items-center">
              <h4 class="aisea-text-16-600-black">
                {{ messages.afterCreate.notificationCreate }}
              </h4>
            </div>
            <div class="vx-row gap-6">
              <div class="vx-col w-full mw">
                <p class="aisea-text-14-400-black">
                  {{ messages.afterCreate.notificationFollowingActions }}
                </p>
              </div>
              <div class="vx-col w-full mw">
                <p class="aisea-text-14-400-black">
                  {{ messages.enterpriseInfo.loginKey }}: {{ loginKey }}
                </p>
                <p class="aisea-text-14-400-black">
                  {{ messages.afterCreate.userID }}
                </p>
                <p class="aisea-text-14-400-black">
                  {{ messages.afterCreate.password }}
                </p>
                <p class="lgoin-btn-wrapper flex justify-end">
                  <vs-button
                    id="link-to-login-enterprise-button"
                    class="
                      text-center
                      vs-con-loading__container
                      aisea-text-14-400-white
                      px-10
                    "
                    @click="handleClickLoginBtn"
                  >{{ messages.afterCreate.login }}
                  </vs-button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import {AiseaApiFactory} from "@/api/aisea/apiFactory";
import GtagService from "@/services/gtagService";

const enterpriseContractApi = AiseaApiFactory.get("enterpriseContract");
import {PostcodeApiFactory} from "@/api/postcode/apiFactory";

const postcodeApi = PostcodeApiFactory.get("postcode");
import {generatePassword} from "@/utils/PasswordUtil";

const URL_TERMS_OF_SERVICE = "https://aisea.net/aisea-pro-terms/";
const URL_PRYVACY_POLICY = "https://aisea.net/privacy_policy/";
const MESSAGES = {
  accountInfo: {
    department: "担当者部署",
    emailAddress: "メールアドレス",
    name: "担当者名",
    nameKana: "担当者名(カナ)",
    password: "パスワード",
    passwordLabel: "パスワード(自動生成パスワード)",
    passwordExplanation: "※任意のパスワードに変更できます。(8文字以上の半角英数字記号が利用可能)",
    title: "担当者役職",
  },
  enterpriseInfo: {
    address: "住所",
    emailAddress: "メールアドレス(ユーザーID)",
    loginKey: "法人ID",
    loginKeyLabel: "法人ID(ご希望のIDを入力)",
    loginKeyExplanation: "※半角英数字、記号のピリオド(.)・アンダースコア(_)・ハイフン(-)・アットマーク(@)が利用可能",
    name: "法人名",
    nameKana: "法人名(カナ)",
    zipCode: "郵便番号",
    phoneNumber: "代表電話番号",
  },
  beforeCreate: {
    titleFirstHalf: "必要事項を入力してください。「",
    titleSecondHalf: "」は入力必須項目です。",
    placeHolder: "メールアドレスを入力",
    mailAddress: "メールアドレス",
    send: "登録",
    searchAddress: "住所検索",
  },
  afterCreate: {
    notificationCreate: "新規アカウントが発行されました。",
    notificationFollowingActions:
      "登録したメールアドレスにアカウント発行完了をお知らせするメールを送信しました。続けてログインする場合、以下情報を入力してログインしてください。",
    userID: "ユーザーID: ご登録いただいたメールアドレス",
    password: "パスワード: 設定いただいたパスワード",
    login: "ログイン"
  },
  nav: {
    termsOfService: "利用規約",
    privacyPolicy: "プライバシーポリシー",
  },
};

const PLACEHOLDERS = {
  accountInfo: {
    department: "例)船員管理部",
    name: "例)アイディア　太郎",
    nameKana: "例)アイディア　タロウ",
    password: "例)sjsk4dfgh02kL",
    title: "例)課長",
  },
  enterpriseInfo: {
    address: "例)東京都渋谷区千駄ヶ谷3-14-5 スカイビル8F",
    emailAddress: "例)taro.aidea@aidea.biz",
    loginKey: "例)aidea-corporation",
    name: "例)アイディア株式会社",
    nameKana: "例)アイディアカブシキガイシャ",
    zipCode: "例)1550011",
    phoneNumber: "例)0312345678",
  },
};

export default {
  name: "EnterpriseAddForm",
  mixins: [],
  props: {
    urlTermsOfService: {type: String, default: URL_TERMS_OF_SERVICE},
    urlPryvacyPolicy: {type: String, default: URL_PRYVACY_POLICY},
    messages: {type: Object, default: () => MESSAGES},
    handleSuccessCreateEnterprise: {
      type: Function, default: () => {
      }
    },
    placeholders: {type: Object, default: () => PLACEHOLDERS},
  },
  components: {},
  data() {
    return {
      backgroundLoading: "primary",
      colorLoading: "#fff",
      isEnterpriseCreateSuccess: false,
      loginKey: "",
      enterpriseName: "",
      enterpriseNameKana: "",
      address: "",
      phoneNumber: "",
      department: "",
      title: "",
      zipCode: "",
      accountName: "",
      accountNameKana: "",
      mailAddress: "",
      password: "",

      isOptin: false,
      isPasswordShow: true,
      res: {},
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.isOptin;
    },
    isZipCodeValid() {
      return (
        this.zipCode.length > 0 &&
        this.errors.first("enterpriseInfo.zipCode") === undefined
      );
    },
    certificationCode() {
      return this.$route.query.cc || "";
    },
    contractInfo() {
      return {
        account_info: {
          department: this.department,
          email_address: this.mailAddress,
          login_key: this.mailAddress,
          name: this.accountName,
          name_kana: this.accountNameKana,
          password: this.password,
          title: this.title,
        },
        certification_code: this.certificationCode,
        enterprise_info: {
          address: this.address,
          email_address: this.mailAddress,
          login_key: this.loginKey,
          name: this.enterpriseName,
          name_kana: this.enterpriseNameKana,
          phone_number: this.phoneNumber,
          zip_code: this.zipCode,
        },
      };
    },
    validationResultsFromApi() {
      return (
        (this.res && this.res.data && this.res.data.validation_results) || []
      );
    },
    passwordIconType() {
      return this.isPasswordShow ? "visibility" : "visibility_off";
    },
    passwordInputType() {
      return this.isPasswordShow ? "text" : "password";
    },
  },
  methods: {
    openLoadingContained(
      containerSelector = "#create-enterprise-button-with-loading"
    ) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: containerSelector,
        scale: 0.45,
      });
    },
    closeLoadingContained(
      containerSelector = "#create-enterprise-button-with-loading"
    ) {
      this.$vs.loading.close(`${containerSelector} > .con-vs-loading`);
    },
    async createEnterprese() {
      const result = this.$validator.validateAll();
      if (result) {
        this.openLoadingContained();
        try {
          this.res = await this.postEnterpriseContracts(this.contractInfo);
          if (this.res.status !== true) throw new Error();
          this.successCreate();
        } catch (e) {
          this.failureCreate();
        }
      }
    },
    successCreate() {
      this.closeLoadingContained();
      setTimeout(() => {
        this.isEnterpriseCreateSuccess = true;
        this.handleSuccessCreateEnterprise();
      }, 1000);

      // コンバージョン アクション
      GtagService.crewDefinitiveRegistration();
    },
    failureCreate() {
      this.closeLoadingContained();
      this.isEnterpriseCreateSuccess = false;
      this.validationResultsFromApi.forEach(({target, message}) => {
        this.errors.add({
          field: target,
          msg: message,
        });
      });
      // accountInfo.loginKeyのエラーを追加で表示する
      this.$vs.notify({
        title: `法人を新規登録できませんでした`,
        text: `${this.errors.first("accountInfo.loginKey") || ""}`,
        color: "danger",
        iconPack: "feather",
        icon: "icon-x-square",
      });
    },
    successSearchAddress() {
      this.closeLoadingContained("#search-address-button-with-loading");
    },
    failureSearchAddress() {
      this.closeLoadingContained("#search-address-button-with-loading");
      this.errors.add({
        field: "enterpriseInfo.Address",
        msg: "住所を取得できませんでした。郵便番号をご確認ください。",
      });
    },
    async getEnterpriseContracts(cc = this.certificationCode) {
      return enterpriseContractApi.getContracts({
        cc,
      });
    },
    async postEnterpriseContracts(payload) {
      return await enterpriseContractApi.postContracts(payload);
    },
    async searchAddress(zipCode) {
      return await postcodeApi.show(zipCode);
    },
    async handleClickSearchAddressBtn() {
      const result = await this.$validator.validate("enterpriseInfo.zipCode");
      if (result) {
        this.openLoadingContained("#search-address-button-with-loading");
        try {
          const res = await this.searchAddress(this.zipCode);
          this.address = res.data[0].allAddress;
          this.successSearchAddress();
        } catch (e) {
          this.failureSearchAddress();
        }
      }
    },
    async handleClickShowPasswordBtn() {
      this.isPasswordShow = !this.isPasswordShow;
    },
    handleClickLoginBtn() {
      this.$router.push({name: "login-enterprise"});
    },
  },
  beforeCreate() {
  },
  async created() {
    // certificationCodeからmailAddressを取得
    this.getEnterpriseContracts(this.certificationCode).then((res) => {
      if (res.status !== true) throw new Error();
      this.mailAddress = res.data.email_address;
    }).catch(() => {
      this.$router.push({name: "login-enterprise"});
    });
    // password生成
    this.password = generatePassword();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#enterprise-create-form-wrapper {
  filter: drop-shadow(0px 0px 30px rgba(112, 122, 141, 0.3));
  border-radius: 10px;

  .enterprise-create-form {
    max-width: 577px;

    .vx-card__collapsible-content {
      height: 100%;
    }

    .vx-card__body {
      height: 100%;
      padding: 2rem;
    }

    .vs-con-input-label.is-label-placeholder {
      margin-top: 30px;
    }

    .con-slot-label {
      z-index: 201;
    }

    .vs-checkbox {
      flex-shrink: 0;
      border-radius: 4px;
    }

    span.required:after {
      content: "*";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }

    .required label:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
      font-family: $aisea-font-family;
    }

    .vs-input {
      :disabled {
        background-color: $aisea-white;
        opacity: unset;
      }
    }

    .input-zip-code {
      width: 150px;
    }

    .input-password {
      .vs-input--icon {
        top: unset;
        right: 12px;
        border: none;
      }
    }

    .search-address-btn {
      font-size: 14px !important;
      font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN",
      "Hiragino Sans", "BIZ UDPGothic", Meiryo, sans-serif;
      font-weight: 400;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }

    .material-icons-outlined {
      &.visibility_off {
        &::before {
          content: "visibility_off";
        }
      }

      &.visibility {
        &::before {
          content: "visibility";
        }
      }
    }

    #link-to-login-enterprise-button {
      width: 130px;
    }
  }
}
</style>
